/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Share_RestrictionInputs */

const en_playbar_share_restriction = /** @type {(inputs: Playbar_Share_RestrictionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can only share documents that you uploaded`)
};

const es_playbar_share_restriction = /** @type {(inputs: Playbar_Share_RestrictionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo puedes compartir documentos que hayas subido`)
};

/**
* | output |
* | --- |
* | "You can only share documents that you uploaded" |
*
* @param {Playbar_Share_RestrictionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_share_restriction = /** @type {((inputs?: Playbar_Share_RestrictionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Share_RestrictionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_share_restriction(inputs)
	return en_playbar_share_restriction(inputs)
});